/* eslint-disable max-len */
import { DisplayElementModel } from './display-element.model';
import { BlockTypeModel } from './block-type.model';
import { BehaviorSubject } from 'rxjs';
import { DistributionBlockTypeEnum } from '../../../Discover/Targeting/enums/distribution-block-type.enum';
import { BriefingBlockTypeEnum } from '../../../Monitor/Briefings/enums/briefing-block-type.enum';


export enum LayoutBlockTypesEnum {
    distributionOne = DistributionBlockTypeEnum.oneColumnLayout,
    distributionTwo = DistributionBlockTypeEnum.twoColumnLayout,
    distributionThree = DistributionBlockTypeEnum.threeColumnLayout,
    briefingOne = BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,
    briefingTwo = BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,
    briefingThree = BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT
};


export class BlockModel {
    id: number;
    type: BlockTypeModel;
    displayElement: DisplayElementModel;

    canMoveUp: boolean = false;
    canMoveUpIntoLayout: boolean = false;
    canMoveDownIntoLayout: boolean = false;
    canMoveUpIntoCurator: boolean = false;
    canMoveDownIntoCurator: boolean = false;
    canMoveDown: boolean = false;
    canMoveLeft: boolean = false;
    canMoveRight: boolean = false;
    // TODO : remove and rely on canAddOrRemove, canMove, and canEdit
    actionable: boolean = true;
    draggable: boolean = true;
    errors: string[] = [];

    clickOutsideComparisonRegex = /(agpr-block)|(agpr-formField)|(agpr-dialog)|(agpr-textStyleField)|(agpr-dropdown)|(agpr-rightSidebar)|(p-scrollpanel-bar)|(p-autocomplete-panel)|(p-autocomplete-items)|(p-datepicker)|(agpr-button)|(agpr-takeOverPanel-focusClose)|(agpr-radio-input)|(agpr-takeOverPanel)|(agpr-clickOutsideExcluded)|(agpr-datePicker)|(agpr-layoutBlock)|(ck-toolbar)|(agpr-curatorBlock)/;

    cols: number;
    rows: number;
    x: number;
    y: number;

    maxItemCols?: number;
    minItemCols?: number;
    maxItemRows?: number;
    minItemRows?: number;

    canAddOrRemove: boolean = true;
    canMove: boolean = true;
    canEdit: boolean = true;
    canDuplicate: boolean = true;
    canAddChart: boolean = false;
    canEditChart: boolean = true;
    canAnnotate: boolean = false;
    renderedOutput: string = null;

    // f/e only, this is used to store the image size
    imageFileSize: number;

    componentChange$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    readonly uniqueId: number = Math.random();

    constructor(id?: number, type?: BlockTypeModel, displayElement?: DisplayElementModel, idPrefix?: string) {
        this.id = id;
        // Type may not be set, if it is set, clone it
        this.type = type && type.clone ? type.clone() : type;
        this.displayElement = displayElement;
    }

    /**
     * Creates a full copy of a block
     */
    clone(): BlockModel {
        const newBlock = new BlockModel();
        newBlock.id = this.id;
        newBlock.type = this.type;
        newBlock.displayElement = this.displayElement ? this.displayElement.clone() : null;

        newBlock.canDuplicate = this.canDuplicate;
        newBlock.canMoveUp = this.canMoveUp;
        newBlock.canMoveDown = this.canMoveDown;
        newBlock.canEditChart = this.canEditChart;
        newBlock.canAnnotate = this.canAnnotate;
        newBlock.renderedOutput = this.renderedOutput;
        newBlock.errors = this.errors;

        newBlock.cols = this.cols;
        newBlock.rows = this.rows;
        newBlock.x = this.x;
        newBlock.y = this.y;

        return newBlock;
    }

    equals(other: BlockModel) {
        if (!other) {
            return false;
        }
        if (this.id !== other.id) {
            return false;
        }

        if (!this.type || !other.type || this.type.key !== other.type.key) {
            return false;
        }

        if (!this.displayElement.isEqual(other.displayElement)) {
            return false;
        }

        return true;
    }

    isLayoutBlockType(): boolean {
        return (Object.values(LayoutBlockTypesEnum) as string[]).includes(this.type.key);
    }
}
